import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from 'react-intl';
class JustAskSummary extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {justAskDetails, style} = this.props;

        if (!justAskDetails || !justAskDetails.get('details') || justAskDetails.get('details').count() === 0) {
            return null;
        }
        let justAskTotal = 0;

        justAskDetails
            .get('details')
            .forEach((item) => {
                justAskTotal += (parseInt(item.get('quantity')) * parseInt(item.get('commision')));
            });

        const labelStyle = {
            display: 'inline-block',
            paddingRight: '2px'
        };

        return (
            <span style={style}>

                <label style={labelStyle}>Total Commission:</label>
                <FormattedNumber value={justAskTotal} style="currency" currency="USD"/>
            </span>
        );
    }
}

JustAskSummary.propTypes = {
    justAskDetails: PropTypes.object,
    style: PropTypes.object
};
export default JustAskSummary;



// WEBPACK FOOTER //
// ./src/components/just-ask/JustAskSummary.js